import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
  },
middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'user/setUser',
          'user/clearUser',
          'user/setInitialized'
        ],
        ignoredActionsPaths: [
          'payload.user', 
          'payload.metadata',
          'payload',
          'meta.arg'
        ],
        ignoredPaths: [
          'user.user',
          'user.user.metadata'
        ],
        warnAfter: 64,
      },
      immutableCheck: {
        ignoredPaths: ['user.user']
      }
    }),
});

export default store;